import ViewDetails from "../../utils/utilities/ViewDetails";

import { Tab } from "@mui/material";

import ContactPageOutlinedIcon from '@mui/icons-material/ContactPageOutlined';
import ReceiptLongRoundedIcon from '@mui/icons-material/ReceiptLongRounded';
import StyleOutlinedIcon from '@mui/icons-material/StyleOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import InventoryOutlinedIcon from '@mui/icons-material/InventoryOutlined';

// Tabs
import ProfileTab from "./Tabs/Profile";
// import SecurityTab from "./Tabs/Security";

  const tabContent = [
    {panel: "profile", content: <ProfileTab />},
  ]

const ViewVendor = () => {

  const tabs = [
    {label: "Profile", icon: <ContactPageOutlinedIcon fontSize="small" />},
    {label: "Sales", icon: <ReceiptLongRoundedIcon fontSize="small" />},
    {label: "Shipments", icon: <LocalShippingOutlinedIcon fontSize="small" />},
    {label: "Requests", icon: <InventoryOutlinedIcon fontSize="small" />},
    {label: "Custom Orders", icon: <StyleOutlinedIcon fontSize="small" />}
  ];

  return (
    <ViewDetails title="Vendor" identifier="brand_name" tabs={tabs} tabContent={tabContent} isProfile={true} url="vendors">

    </ViewDetails>
  )
};

export default ViewVendor;